import { Box, Typography } from '@mui/material'
import Link from 'next/link'

import { runClientEff } from '@ecm/effect'
import Button from '@ecm/ui/element/Button'
import CloudflareImage from '@ecm/ui/element/CloudflareImage'
import Color from '@ecm/ui/element/Color'

import sidebarCtaIllustration from '/public/images/illustration/sidebarCta.png'

const SidebarCta = () => {
  const onChoosePlanBtnClick = () => {
    runClientEff(eff => {
      eff.trackGa({ event: 'blogSidebarButtonClick' })
    })
  }

  return (
    <Box
      id="sidebarCta"
      p="1.5em 1em"
      bgcolor={Color.smoke.normal}
      borderRadius="8px"
      position="sticky"
      top="92px"
    >
      <Typography variant="h5" component="h3" color={Color.slate.normal} mb="1.5em">
        Access postal mail anywhere with a virtual MailBox
      </Typography>
      <CloudflareImage src={sidebarCtaIllustration} />
      <Typography variant="p3" margin="1.5em 0 0">
        Get your physical mail professionally scanned and <b>ready to view on any device</b>
      </Typography>
      <Link passHref href="/pricing">
        <Button primary narrow short margin="1em 0 0" width="100%" onClick={onChoosePlanBtnClick}>
          Choose a plan
        </Button>
      </Link>
    </Box>
  )
}

export default SidebarCta
